// JobApplicationButton.jsx
import React from 'react';



const JobApplicationButton = ({ onClick }) => (
  <div className=" h-[200px] rounded-lg shadow-md p-6 text-center">
    <h3 className="text-xl font-semibold text-gray-800 mb-4">Apply Now</h3>
    <button
      onClick={onClick}
      className="bg-green-400 hover:bg-green-700 text-white font-semibold py-2 px-6 rounded-full transition-colors duration-300"
    >
      Open Application Form
    </button>
  </div>
);


export default JobApplicationButton